import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React from 'react';

const useLanguageList = () => {
  const label_combo_label = FindLangKey(
    'lab-patient-type-lab'
  );

  const label_confirm_type = FindLangKey(
    'lab-patient-type-confirmation'
  );

  const label_date_insert = FindLangKey(
    'lab-patient-date-insert'
  );
  const label_file_number = FindLangKey(
    'lab-patient-file-number'
  );
  const label_patient_number_request = FindLangKey(
    'lab-patient-number-request'
  );
  const label_patient_name_patient = FindLangKey(
    'lab-patient-name-patient'
  );
  const label_patient_family_patient = FindLangKey(
    'lab-patient-family-patient'
  );
  const lab_patient_patient_id_textbox = FindLangKey(
    'lab-patient-patient-id-textbox'
  );

  return [
    label_combo_label,
    label_confirm_type,
    label_date_insert,
    label_file_number,
    label_patient_number_request,
    label_patient_name_patient,
    label_patient_family_patient,
    lab_patient_patient_id_textbox,
  ];
};

export default useLanguageList;
